import React from 'react'

const Secgen = () => {
  return (
    <section className='flex flex-col justify-center items-center gap-4 mt-48 md:mt-10 p-2' >

    <div className='border-2 border-cps-grey p-4 rounded-xl bg-white flex flex-col-reverse md:flex-row gap-4'>
            <div className='md:w-[70%] w-full flex flex-col justify-evenly'>
                <h1  className='text-2xl'>
                    
                </h1>
                
                
                    Prithvi Easwaramoorthy | Shruti Malaar Damother | Harivathsan HK | Praneeth V
                <h3 className='font-bold text-cps-grey text-3xl'>From The Secretariats</h3>
                <p className='font-regular text-base opacity-35	'> Greetings!<br></br><br></br>

“Debate is a constructive conversation, because no one holds a monopoly on being right”
With this belief at core Chennai Public School Anna Nagar  is proud to welcome you all to the 4 Th edition of CPS PRIME Model United Nations. 
Be part of Chennai’s best mun where memories are made and leaders are shaped. An arena to showcase your diplomatic skills , debating mindset and spokesman ship . CPS PRIME MUN is more than just a conference, it is an opportunity to exhibit your critical thinking and leadership acumen. Engage in thought provoking committees that are led by an exceptional executive board where every word spoken adds to your growth .
The knowledge demanding agendas will spark new insights and fresh perspectives into your minds . CPS has worked tirelessly to make sure that PRIME enables everyone’s thoughts to be heard loud and clear through nurturing global awareness and igniting passion for policy making,which will unfold in the intellectual committees . 
With that We would like all of you to register for CPS prime taking place on 1st and 2nd August . If you have any quesries feel free to reach out to us and as the secretariat we assure you that this event will not only be a learning experience but also a journey that you will cherish even after the final gavel drops.

Thank You
 
                </p>
                <br></br>
                <h1 className='text-cps-black font-bold text-4xl'>CPS Prime MUN 4.0</h1>

            </div>
            <div className='md:w-[30%] w-full flex items-center justify-center shadow-lg shadow-[#1111F1]'>
                <img src= "https://i.ibb.co/cXsF2HsH/SECRETERIATS.png" alt="Secretary General" className='rounded-md' />
            </div>


        </div>

    </section>



  )
}



export default Secgen